import { service } from "../server/request";

export const getCalendarHoliday = async (reqData) => {
  try {
    const url = `mealManage/catererHolidays/search/findByCatererIdAndDateBetween`;
    const queryString = `?catererId=${reqData.catererId}&startDate=${reqData.startDate}&endDate=${reqData.endDate}`
    const resp = await service({
      method: "GET",
      url: url+queryString,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    throw { error: true, errorMessage: ex.errorMessage || ex.message };
  }
};
export const createCalendarHoliday = async (reqData) => {
  try {
    const url = `mealManage/catererHolidays`;
    const resp = await service({
      method: "POST",
      url: url,
      data: reqData,
    });
    if (resp.status === 201) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    throw { error: true, errorMessage: ex.errorMessage || ex.message };
  }
};
export const updateCalendarHoliday = async (reqData, id) => {
  try {
    const url = `/mealManage/catererHolidays/${id}`;
    const resp = await service({
      method: "PUT",
      url: url,
      data: reqData,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    throw { error: true, errorMessage: ex.errorMessage || ex.message };
  }
};
export const deleteCalendarHoliday = async (id) => {
  try {
    const url = `/mealManage/catererHolidays/${id}`;
    const resp = await service({
      method: "DELETE",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data.resp };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};

